<template>
  <div>
    <!-- Inspektorat Menu -->
    <div
      class="inspektorat-menu"
      :class="{ open: isInspektoratMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>INSPEKTORAT</span>
          </li> 
        -->
        <li>
          <RouterLink to="/inspektorat">
            PBTCare
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/inspektorat/ahli-pbt">
            Ahli Majlis PBT
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/inspektorat/pasar-pbt">
            Pasar Sementara
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/inspektorat/penguatkuasaan-pbt">
            Penguatkuasaan PBT
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/inspektorat/senarai-pbt">
            Senarai PBT
          </RouterLink>
        </li>
      </ul>
    </div>
    <div
      v-if="isInspektoratMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isInspektoratMenuOpen"
      class="inspektorat-toggle-button"
      @click="toggleInspektoratMenu"
    >
      <span class="vertical-text">INSPEKTORAT</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isInspektoratMenuOpen = ref(false)

const toggleInspektoratMenu = () => {
  isInspektoratMenuOpen.value = !isInspektoratMenuOpen.value
  if (isInspektoratMenuOpen.value) {
    closeMainMenu()
  }
}


const closeMenus = () => {
  isInspektoratMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-inspektorat-menu', () => {
  isInspektoratMenuOpen.value = false
})
</script>

<style scoped>
/* Inspektorat Menu */
.inspektorat-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s, z-index 0.3s; /* Z-index transition */
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;

}

.inspektorat-menu.open {
  transform: translateX(0);

}

.inspektorat-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.inspektorat-menu li {
  margin-bottom: 10px;
}

.inspektorat-menu a,
.inspektorat-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Inspektorat Toggle Button */
.inspektorat-toggle-button {
  position: fixed;
  top: 40%;
  right: 0;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 5px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.inspektorat-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
